// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__3-rVM","separator":"styles_separator___WYet"};